<template>
    <div class="content-wrap">
        <van-form @submit="bindphone">
            <van-field
                    class = "weball-font-14"
                    v-model="phone"
                    type="tel"
                    name="手机号"
                    label="手机号"
                    placeholder="请输入手机号"
            ></van-field>
            <van-field
                    class = "weball-font-14"
                    v-model="vcode"
                    center
                    clearable
                    label="短信验证码"
                    placeholder="请输入短信验证码">
                <van-button class="vcode-btn weball-font-14" v-if="time>0" slot="button" size="small" type="info"  native-type="button" disabled >
                    <van-count-down class = "weball-font-14" :time="time"  style="color:#fff;font-size: 14px" @finish="finished">
                        <template v-slot="timeData">
                            <span >剩余</span>
                            <span >{{ timeData.seconds }}</span>
                            <span >秒</span>
                        </template>
                    </van-count-down>
                </van-button>
                <van-button  class="vcode-btn weball-font-14" v-else slot="button" size="small" type="info" @click="send_sms" native-type="button">
                    <span >发送验证码</span>
                </van-button>
            </van-field>
            <van-field
                    class = "weball-font-14"
                    v-model="pwd"
                    type="password"
                    name="密码"
                    label="密码"
                    placeholder="请输入密码"
            ></van-field>
            <van-field
                    class = "weball-font-14"
                    v-model="repwd"
                    type="password"
                    name="重复密码"
                    label="重复密码"
                    placeholder="请再次输入密码"
            ></van-field>
            <div style="margin: 32px 16px;">
                <van-button class = "weball-font-14"  block type="info" native-type="submit">立即绑定</van-button>
<!--                <div style="text-align: center;font-size: 16px; color: red;margin: 10px">绑定手机号</div>-->
            </div>

        </van-form>
    </div>
</template>
<style>
    .content-wrap{
        padding: 15px;
        margin-top:10%;
    }
    .vcode-btn{
        max-width: 100px;
        min-width: 100px;
    }
</style>
<script>
    export default {
        name: 'bindphone',
        data() {
            return {
                params:null,
                vcode:'',
                phone: '',
                pwd:'',
                repwd: '',
                time:0,
                interval:60*1000,
            }
        },
        created: function () {
            this.init_vcode_time();
            this.params = this.weutil.getParams(window.location.href);
        },
        methods: {
            finished:function(){
                this.time = 0;
            },
            init_vcode_time:function(){
                let oldtime = this.weconfig.getVcodeTime();
                let nowtime = Date.now();
                this.time = nowtime - oldtime >= this.interval ? 0 : this.interval - (nowtime - oldtime)
            },
            send_sms:function(){
                if(!this.weutil.isPoneAvailable(this.phone)){this.$toast('手机号不正确！');return;}
                let that = this;
                this.weapi.request({
                    url: 'send_vcode',
                    method: 'post',
                    params: {'phone':this.phone},
                }).then(res => {
                    if (res.data.code === '200') {
                        that.weconfig.setVcodeTime(Date.now());
                        that.init_vcode_time();
                    }
                    else {
                        that.$toast(res.data.message);
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                }).finally(function (response) {
                })
            },
            bindphone: function () {
                if(!this.weutil.isPoneAvailable(this.phone)){this.$toast('手机号不正确！');return;}
                if(this.vcode===''){this.$toast('请输入手机验证码！');return;}
                if(this.pwd===''){this.$toast('请输入密码！');return;}
                if(this.repwd!==this.pwd){this.$toast('两次输入的密码不一致！');return;}
                let that = this;
                this.weapi.request({
                    url: 'bindphone',
                    method: 'post',
                    params: {wechat_token : decodeURIComponent(this.params.wechat_token), 'phone':this.phone, 'pwd':this.pwd, 'repwd':this.repwd,'vcode': this.vcode},
                }).then(res => {
                    if (res.data.code === '200') {
                        if(res.data.data.award){
                            that.$dialog.alert({
                                message: '绑定成功！已赠送10个点券'
                            }).then(() => {
                            }).catch(() => {
                            });
                        }
                        this.westore.commit('setToken', decodeURIComponent(res.data.data.access_token));
                        if(this.params.hasOwnProperty('redirect_name')){
                            this.$router.push({ name: decodeURIComponent(this.params.redirect_name), params:this.params })
                        }
                        else{
                            this.$router.push({ name: this.werouter.index.name, params:this.params })
                        }
                    }
                    else {
                        that.$toast(res.data.message);
                    }
                }).catch(function (error) {
                    console.log(error)
                    that.$toast('系统错误，请稍后重试！');
                }).finally(function (response) {
                })
            },
        }
    }
</script>
